export const getIsWantToBecomePartner = (
  value: ["yes" | undefined] | undefined | "yes" | "no"
): "yes" | "no" => {
  if (value && value[0] === "yes") {
    return "yes";
  }
  return "no";
};
